import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { FiSiteDesignBrandPreviewDialogComponent } from './fi-site-design-brand-preview-dialog/fi-site-design-brand-preview-dialog.component';

@Component({
    selector: 'fi-brand-editor-preview-card',
    templateUrl: './fi-brand-editor-preview-card.component.html',
    styleUrls: ['./fi-brand-editor-preview-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-brand-editor-preview-card' },
    standalone: false,
})
export class FiBrandEditorPreviewCardComponent {
    @Input() primaryColor: string;
    @Input() contrastColor: string;
    @Input() logoRef: IMediaBankFileReference;
    @Input() landscapeRef: IMediaBankFileReference;

    constructor(private fiDialogsService: FiDialogsService) {}

    openPreviewDialog() {
        this.fiDialogsService.openAnimatedBottomDialog({
            hideFooter: true,
            hideHeader: true,
            contentComponentRef: FiSiteDesignBrandPreviewDialogComponent,
            contentComponentData: {
                primaryColor: this.primaryColor,
                contrastColor: this.contrastColor,
                logoRef: this.logoRef,
                landscapeRef: this.landscapeRef,
            },
            config: {
                width: '80%',
                height: '70%',
                maxWidth: '95%',
                maxHeight: 'unset',
                panelClass: 'fi-customer-settings-preview-panel',
                autoFocus: false,
            },
        });
    }
}
